/* eslint-disable @typescript-eslint/no-unused-vars */
import { colors } from 'ui/theme/colors';
import { useTreeViewContext } from '../context/TreeViewContext';

const { white, grey1 } = colors;

/**
 * Assigns colors for each nested table row so that their
 * background colors alternate vertically until the depth
 * specified by altRowColorDepth.
 */
export const useGetRowColors = (
  depth: number,
  childRowCount: number,
  parentColor: string = white,
) => {
  const { tableColor = grey1, altRowColorDepth = 0 } = useTreeViewContext();
  const rowIndexArr = [...Array(childRowCount)];

  const altColor = parentColor === white ? tableColor : white;
  const altColorArr = rowIndexArr.map((_, i) => (i % 2 === 0 ? altColor : parentColor));
  const sameColorArr = rowIndexArr.map((_) => parentColor);

  return depth > altRowColorDepth ? sameColorArr : altColorArr;
};
